import {GroupAvatarProps} from './types';

import {P} from '@quarks';
import {StyledAvatar} from './styles';
import {DonutChart} from '../DonutChart';
import {cn} from '@utils';

export const GroupAvatar = ({
  border,
  className,
  size,
  disabled,
  style,
  group,
  strokeWidth = 4,
  ...props
}: GroupAvatarProps) => {
  if (group.workdayCount !== undefined) {
    return (
      <DonutChart
        strokeWidth={strokeWidth}
        className={cn('border-white border-2', className)}
        style={style}
        numberOfMembers={group.memberCount}
        numberOfOfficeDaysOnDay={group.workdayCount}>
        <StyledAvatar
          role="img"
          $disabled={disabled}
          $color={group.color}
          $border={'none'}
          $size={size}
          $borderCorrection={strokeWidth * 2 + 4}
          {...props}>
          {!group.imageUrl && (
            <P
              font="inherit"
              fontWeight="bold">
              {group.emoji || '❓'}
            </P>
          )}
        </StyledAvatar>
      </DonutChart>
    );
  }

  return (
    <StyledAvatar
      className={className}
      role="img"
      $disabled={disabled}
      $color={group.color}
      $border={border}
      $size={size}
      style={style}
      {...props}>
      {!group.imageUrl && (
        <P
          font="inherit"
          fontWeight="bold">
          {group.emoji || '❓'}
        </P>
      )}
    </StyledAvatar>
  );
};
